import { VFC } from 'react'
import { _profilegray, _profilehrborder } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import {} from './'
import {
  Label,
  LabelsContent,
  LabelsWrapper,
  Section,
  sectionBodyStyle,
} from './styles'
import { ProfilePreviewProps } from './types'

export const PersonaSection: VFC<ProfilePreviewProps> = ({
  user: {
    needs: { items: needs },
    solutions: { items: solutions },
  },
}) => {
  if (!(needs.length > 0 || solutions.length > 0)) return <></>
  return (
    <Section>
      <h3>こんな人に会いたい</h3>
      <PersonaDiv>
        {needs.length > 0 && (
          <>
            <h4>今抱えている悩み・相談したいこと（ニーズ）</h4>
            <LabelsWrapper>
              <LabelsContent>
                {needs.map((need) => (
                  <Label key={need}>{need}</Label>
                ))}
              </LabelsContent>
            </LabelsWrapper>
          </>
        )}
        {solutions.length > 0 && (
          <>
            <h4>解決できる・応えることができる（ソリューション）</h4>
            <LabelsWrapper>
              {solutions.map((solution) => (
                <Label key={solution}>{solution}</Label>
              ))}
            </LabelsWrapper>
          </>
        )}
      </PersonaDiv>
    </Section>
  )
}
const PersonaDiv = styled.div`
  ${sectionBodyStyle};
  h4 {
    margin-top: 20px;
    padding: 16px 0;
    border-bottom: 2px solid ${_profilehrborder};
    font-weight: ${fontWeightBold};
    span {
      color: ${_profilegray};
    }
  }
  p {
    padding: 12px 0;
  }
`
